import React, { useState } from 'react';
import { Wrapper } from './style';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { store } from '~/store';

import Close from '~/assets/close-outline.png';
import ModalInquilinoCuritiba from '~/assets/modal-iptu/modal-inquilino-curitiba.webp';
import ModalProprietarioImageAraucaria from '~/assets/modal-iptu/modal-proprietarios-araucaria-image.webp';
import ModalProprietarioNovoSol from '~/assets/modal-iptu/modal-proprietarios-novo-sol.webp';
import ModalProprietarioMkjPinhais from '~/assets/modal-iptu/modal-proprietarios-pinhais-mkj.webp';
import ModalProprietarioAssessoriaImageCentro from '~/assets/modal-iptu/proprietarios-assessoria-image-centro.webp';

export default function ModalIptu() {

  const userType = useSelector(state => state.user.profile.tipoCliente);
  const [showModalIptu, setshowModalIptu] = useState(false);
  const [useModal, setUseModal] = useState(null);
  const loading = useSelector(state => state.properties.loading);
  const [properties, setProperties] = useState([]);


  useEffect(() => {

    var properties = store.getState().properties.properties.properties
    console.log("properties: ", properties)

    if (properties) {
        if ( userType.indexOf('Proprietário') != -1 ) {

            let image_araucaria = "Image Participações S/A Araucária"
            let assessoria = "Assessoria Imobiliária Cons.Laurindo Ltda"
            let image_centro = "Image Participações S/A Centro"
            let mkj = "Mkj Imóveis Ltda"
            let novo_sol = "Novo Sol Assessoria Imobiliária Ltda"

            let find_image_arauc_props = properties.filter(prop => prop.nomeFranquia.indexOf(image_araucaria) != -1)
            if ( find_image_arauc_props.length > 0 ) {
                registerModal(image_araucaria)
            }

            let find_assessoria_props = properties.filter(prop => prop.nomeFranquia.indexOf(assessoria) != -1)
            if ( find_assessoria_props.length > 0 ) {
                registerModal(assessoria)
            }

            let find_mkj_props = properties.filter(prop => prop.nomeFranquia.indexOf(mkj) != -1)
            if ( find_mkj_props.length > 0 ) {
                registerModal(mkj)
            }

            let find_novosol_props = properties.filter(prop => prop.nomeFranquia.indexOf(novo_sol) != -1)
            if ( find_novosol_props.length > 0 ) {
                registerModal(novo_sol)
            }

            let find_imgcentro_props = properties.filter(prop => prop.nomeFranquia.indexOf(image_centro) != -1)
            if ( find_imgcentro_props.length > 0 ) {
                registerModal(image_centro)
            }


        } else {
            let find_cwb_props = properties.filter(prop => prop.endereco.indexOf('Curitiba') != -1)
            if ( find_cwb_props.length > 0 ) {
                registerModal('inquilino-curitiba')
            }
        }

        //executeModal()
    }

  }, [userType, useModal, loading]);

  function executeModal() {

    let modal_storage = window.localStorage.getItem("modal_iptu")
    modal_storage = !modal_storage ? {} : JSON.parse(modal_storage)

    let use_modal_key = null
    Object.keys(modal_storage).forEach(Key=> {
        if ( modal_storage[Key] == "wait" && !use_modal_key) {
            use_modal_key = Key
            modal_storage[Key] = "done"
        }
    })


    switch (use_modal_key) {
        case "Image Participações S/A Araucária":
            setUseModal(ModalProprietarioImageAraucaria)
            break;

        case "Assessoria Imobiliária Cons.Laurindo Ltda":
        case "Image Participações S/A Centro":
            setUseModal(ModalProprietarioAssessoriaImageCentro)
            break;

        case "Mkj Imóveis Ltda":
            setUseModal(ModalProprietarioMkjPinhais)
            break;

        case "Novo Sol Assessoria Imobiliária Ltda":
            setUseModal(ModalProprietarioNovoSol)
            break;

        case "inquilino-curitiba":
            setUseModal(ModalInquilinoCuritiba)
            break;
    
        default:
            break;
    }

    // if (useModal) {
    //     setshowModalIptu(true)
    //     window.localStorage.setItem("modal_iptu", JSON.stringify(modal_storage))
    // }
  }
  
  function registerModal(modal_key) {
    return false
    let modal_storage = window.localStorage.getItem("modal_iptu")
    modal_storage = !modal_storage ? {} : JSON.parse(modal_storage)

    modal_storage[modal_key] = typeof modal_storage[modal_key] != "undefined" ? modal_storage[modal_key] : 'wait'

    window.localStorage.setItem("modal_iptu", JSON.stringify(modal_storage))
  }

  function closeModal() {
    setshowModalIptu(false)
  }

  return (
    <Wrapper className="modal-iptu-component">

        {showModalIptu && (
            <div className="modal-iptu-backdrop">
               <div className='modal-iptu-content'>
                    <img className="close-button" src={Close} onClick={()=>{closeModal()}}/>
                    <img className='modal-iptu-content-image' src={useModal}/>
               </div>
            </div>
        )}
        
    </Wrapper>
  );
}
